import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly visibleMessages = new Set<string>();

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  error(message: string): void {
    if (!message || this.visibleMessages.has(message)) return;
    this.visibleMessages.add(message);
    const notification = this.document.createElement('div');
    notification.className = 'app-notification app-notification-error';
    notification.role = 'alert';
    notification.textContent = message;
    this.document.body.appendChild(notification);
    globalThis.setTimeout(() => {
      notification.remove();
      this.visibleMessages.delete(message);
    }, 5000);
  }
}
